module.exports = __webpack_public_path__ + "img/b57643d.svg";